import {
  GET_ALL_TL_USERS,
  SET_ALL_TL_USERS,
  DELETE_TL_USER,
  DELETE_TL_USER_SUCCESS,
  ADD_TL_USER,
  ADD_TL_USER_SUCCESS,
  GET_TOTAL_PAYOUT_REQUEST,
  GET_DAILY_SALES_REQUEST,
  GET_DAILY_PAYOUT_REQUEST,
  GET_TOTAL_PAYOUT_SUCCESS,
  GET_DAILY_SALES_SUCCESS,
  GET_DAILY_PAYOUT_SUCCESS,
  SET_OFFSET_Y,
  RESET_LEADER_STATE,
} from "./actionTypes";

const initState = {
  token: "",
  data: null,
  isFetchingUsers: true,
  users: [],
  totalUsers: 0,
  dailyPayout: [],
  totalPayout: {},
  dailySale: [],
  offsetYCustomerList: 0,
  offsetYOrderList: 0,
  isFetchingOffers: false,
  contactPermissionStatus: { status: false },
};

export const actions = {
  addUser(userCreds) {
    return {
      type: ADD_TL_USER,
      payload: {
        userCreds,
      },
    };
  },
  getAllUsers(payload) {
    return {
      type: GET_ALL_TL_USERS,
      payload,
    };
  },
  deleteUser(userId) {
    return {
      type: DELETE_TL_USER,
      payload: {
        userId,
      },
    };
  },
  getAllPayoutsRequest: () => ({
    type: GET_TOTAL_PAYOUT_REQUEST,
  }),
  getDailySalesRequest: () => ({
    type: GET_DAILY_SALES_REQUEST,
  }),
  getDailyPayoutRequest: () => ({
    type: GET_DAILY_PAYOUT_REQUEST,
  }),
};

const reducer = (state = initState, action) => {
  switch (action.type) {
    case ADD_TL_USER_SUCCESS: {
      const { data = {} } = action.payload;
      const { user_id = "" } = data;

      const users = [...state.users];

      // if (!user_id) return state;

      // const isUserAlreadyExists = users.find(
      //   user => user.user_id === user_id
      // );

      // if (!isUserAlreadyExists) {
      //   users.unshift(data);
      // }

      return {
        ...state,
        users,
      };
    }

    case SET_ALL_TL_USERS: {
      const {
        users: { users, count },
        replace = false,
      } = action.payload;

      let allUsers = [];

      if (replace) {
        allUsers = users;
      } else {
        allUsers = [...state.users, ...users];
      }

      return {
        ...state,
        users: allUsers,
        totalUsers: count,
        isFetchingUsers: false,
      };
    }

    case GET_ALL_TL_USERS: {
      const { replace = false, isPulled = false } = action.payload;
      let loading = true;

      if (replace && !isPulled) {
        loading = false;
      }

      return {
        ...state,
        isFetchingUsers: loading,
      };
    }

    case DELETE_TL_USER_SUCCESS: {
      const { user_id = "" } = action.payload.data;

      const users = [...state.users].filter((user) => user.user_id !== user_id);

      return {
        ...state,
        users,
      };
    }

    case GET_TOTAL_PAYOUT_SUCCESS: {
      return {
        ...state,
        totalPayout: action.payload,
      };
    }

    case GET_DAILY_SALES_SUCCESS: {
      return {
        ...state,
        dailySales: action.payload,
      };
    }

    case GET_DAILY_PAYOUT_SUCCESS: {
      return {
        ...state,
        dailyPayout: action.payload,
      };
    }

    case SET_OFFSET_Y: {
      const { offset, tabName } = action.payload;

      const offsetObj = {};

      if (tabName === "orders") {
        offsetObj.offsetYOrderList = offset;
      } else {
        offsetObj.offsetYCustomerList = offset;
      }

      return {
        ...state,
        ...offsetObj,
      };
    }

    case RESET_LEADER_STATE: {
      return initState;
    }

    default:
      return state;
  }
};

reducer.initialState = initState;

export default reducer;
